/**
   File upload widget

   Upload files from the client directly to S3.

   .. seealso:: https://blog.fineuploader.com/2013/08/16/fine-uploader-s3-upload-directly-to-amazon-s3-from-your-browser/
*/

import fineUploader from 'fineuploader';
import jqueryCookie from 'jquery.cookie';


function getUploaderOptions($input) {

  var session_params = _.omit($input.data(), [
    'sizeLimit',
    'target',
    'fieldUrl',
    'template',
    'requestEndpoint']
  );

  return {
    request: {
      // required by fine uploader
      endpoint: $input.data("requestEndpoint"),
      accessKey: $input.data("accessKeyId"),
      // optional, but required by django
      customHeaders: {
        "X-CSRFToken": $.cookie("csrftoken")
      }
    },

    cors: {
      expected: true,
      sendCredentials: true  // send cookies, e.g. django authentication
    },

    template: $input.data("template"),

    // REQUIRED: Path to our local server where requests
    // can be signed.
    signature: {
      endpoint: "/application/s3/",
      customHeaders: {
        "X-CSRFToken": $.cookie("csrftoken")
      }
    },

    objectProperties: {
      key: function (fileId) {
        var prefix = $input.data("prefix"),
            filename = this.getName(fileId),
            uuid = this.getUuid(fileId)
            ext = filename.substr(filename.lastIndexOf('.') + 1),
            s3Key = uuid + '.' + ext;

        if (prefix) {
          s3Key = prefix + s3Key;
        }
        return s3Key;
      },
    },

    // OPTIONAL: An endopint for Fine Uploader to POST to
    // after the file has been successfully uploaded.
    // Server-side, we can declare this upload a failure
    // if something is wrong with the file.
    uploadSuccess: {
      endpoint: "/application/s3/success/",
      customHeaders: {
        "X-CSRFToken": $.cookie("csrftoken")
      }
    },

    // USUALLY REQUIRED: Blank file on the same domain
    // as this page, for IE9 and older support.
    iframeSupport: {
      localBlankPagePath: "/public/application-s3-success.html"
    },

    // optional feature
    chunking: {
      enabled: true
    },

    // optional feature
    resume: {
      enabled: true
    },

    // optional feature
    deleteFile: {
      enabled: true,
      method: "POST",
      endpoint: "/application/s3/delete/",
      customHeaders: {
        "X-CSRFToken": $.cookie("csrftoken")
      }
    },

    session: {
      endpoint: $input.data("fieldUrl"),
      params: session_params,
    },

    // optional feature
    validation: {
      itemLimit: $input.data("itemLimit") || 25,
      sizeLimit: $input.data("sizeLimit")
    },

    thumbnails: {
      placeholders: {
        // notAvailablePath: "/public/img/not_available-generic.png",
        // waitingPath: "/public/img/waiting-generic.png"
        notAvailablePath: "/public/media/icons/icon_file.png",
        waitingPath: "/public/media/icons/icon_file.png"
      }
    }
  };
}


function saveAttachmentsString(context, filesDetailsString, url, cb) {
    var saveParams = _.omit($(context).data(), [
      'sizeLimit',
      'target',
      'fieldUrl',
      'template',
      'requestEndpoint',
      'fineuploader',
      'prefix',
    ]);
    saveParams["value"] = filesDetailsString;

    $.ajax({
       context: context,
       data: saveParams,
       type: "POST",
       url: url,
       headers: {
         "X-CSRFToken": $.cookie("csrftoken")
       }
    }).done(function(data) {
      if (cb) {
        cb();
      }
    });
}


function onUploadComplete(e, id, name, response) {
  maybeHideUploadButtonIfNoMoreAllowed(this);

  var $fileEl = $(this).fineUploaderS3("getItemByFileId", id),
      $input, filesDetails, filesDetailsString;

  if (response.success) {
    $input = $("#" + $(this).data("target"));
    $input.val($input.val() + "\n" + response.key);
    filesDetails = $input.data("filesDetails") || {},

    filesDetails[response.uuid] = {
      name: name,
      url: response.key,
      uuid: response.uuid
    };
    filesDetailsString = JSON.stringify(filesDetails);
    $input.data("filesDetails", filesDetails).val(filesDetailsString).trigger("change");
    saveAttachmentsString(this, filesDetailsString, $(this).data('fieldUrl'));
  }
}


function maybeHideUploadButtonIfNoMoreAllowed(uploaderDiv, iteration) {
  iteration = iteration || 0;

  var $div = $(uploaderDiv),
      shouldHideUploaderAfterItemLimit = !!$div.data("hideUploaderAfterItemLimit"),
      limit = $div.data("itemLimit"),
      isAboveLimit = $div.fineUploaderS3("getNetUploads") >= limit,
      maxRecurse = 50;

  // Don't recurse more than 50 times.
  if (iteration > maxRecurse || !shouldHideUploaderAfterItemLimit) {
    return;
  } else if (isAboveLimit) {
    $div.find(".upload-row").hide();
  } else {
    setTimeout(function() {
      maybeHideUploadButtonIfNoMoreAllowed(uploaderDiv, iteration + 1);
    }, 100);
  }
}


function maybeShowUploadButtonIfMoreAllowed(uploaderDiv) {
  var $div = $(uploaderDiv),
      limit = $div.data("itemLimit");

  if ($div.fineUploaderS3("getNetUploads") < limit) {
    $div.find(".upload-row").show();
  }
}


$(function () {
  // Load FineUploader for all existing elements
  if ($(".js-minerva-form-uploader").fineUploaderS3) {
    $(".js-minerva-form-uploader").each(function() {
      var $this = $(this),
          $textarea;

      $this.fineUploaderS3(getUploaderOptions($this)).on('complete', onUploadComplete).on('deleteComplete', function(e, id, xhr, isError) {
        maybeShowUploadButtonIfMoreAllowed(this);
        var $input = $("#" + $this.data("target")),
            filesDetails = $input.data("filesDetails") || {},
            filesDetailsString,
            uuid = $.parseJSON(xhr.response).uuid;
        delete filesDetails[uuid];
        filesDetailsString = JSON.stringify(filesDetails);
        if (filesDetailsString === "{}") {
          filesDetailsString = "";
        }
        saveAttachmentsString(this, filesDetailsString, $this.data("fieldUrl"));
        $input.data("filesDetails", filesDetails).val(filesDetailsString);
      }).on('sessionRequestComplete', function(e, data, isSuccess, xhr) {
        if (data && data.length) {
          $this.show();
          $this.find(".js-empty-table").addClass("hide");
        }
      }).on('submitted', function(e) {
        $this.find(".js-empty-table").addClass("hide");
      });

      $textarea = $this.find("textarea");
      if ($textarea.val()) {
        $textarea.data("filesDetails", $.parseJSON($textarea.val()));
      }
      maybeHideUploadButtonIfNoMoreAllowed(this);
    });
  }

  // Tooltip for title of document
  setInterval(function() {
    $.each($(".js-to-receive-html-title"), function() {
      if ($(this).attr("title") === undefined) {
        $(this).
          attr("title", $(this).siblings(".qq-upload-file").text()).
          tooltip({
            tooltipClass: 'white bg-darkest col col-2 p1'
        });
      }
    });
  }, 1000);
});



// WEBPACK FOOTER //
// lib/js/minerva-form/uploader.js